import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";
import { Album } from "./album";
import { AudioInfoItem } from "./audio_info_item";
import { VideoInfoItem } from "./video_info_item";

export interface PlaybackInfo {
    audioInfo?: {
        lq: AudioInfoItem
        hq?: AudioInfoItem
    };
    videoInfo?: {
        lq: VideoInfoItem
        hq?: VideoInfoItem
    }
}
export class WaveInfo {
    @JsonProperty({ type: 'true' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'WaveInfo' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    gray: string;
    @JsonProperty({ type: 'string' })
    red: string;

    get colored() {
        return this.red
    }
}

export class Media extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'Media' })
    MODELNAME: string;


    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    track_name_full: string;

    @JsonProperty({ type: 'object', required: false })
    stream_info?: PlaybackInfo;

    @JsonProperty({ type: 'string' })
    tag_name: string;

    @JsonProperty({ type: 'string?' })
    key?: string;

    @JsonProperty({ type: 'string?' })
    image?: string;

    @JsonProperty({ type: 'number' })
    position: number;

    @JsonProperty({ type: 'boolean' })
    in_crate: boolean;

    @JsonProperty({ type: 'number' })
    download_count: number;

    @JsonProperty({ type: 'Album?', clazz: Album, required: false })
    album?: Album;

    @JsonProperty({ type: 'WaveInfo', clazz: WaveInfo, required: false })
    waves: WaveInfo;

    @JsonProperty({ type: 'WaveInfo', clazz: WaveInfo, required: false })
    waves_black: WaveInfo;

}



// WEBPACK FOOTER //
// ./src/api/src/models/media.ts